import { useSearchParams } from "react-router-dom";
import { useCallback, useMemo } from "react";

export type ParamType = string | number | null | undefined;

export enum QUERY_STRING_KEYS {
  SELECTED_CONTRACT_KEY = "docEntry",
  SELECTED_CUSTOMER_KEY = "customer",
  SELECTED_ORDER_KEY = "order",
  SELECTED_TAB_KEY = "tab",
  FORM_OPEN = "requestOrderFormOpen",
}

export const useQueryParam = (
  paramName: string | undefined
): [string | undefined, (paramValue: ParamType) => void] => {
  const [search, setSearchParams] = useSearchParams();
  const getParam = useCallback(
    (paramName: string) => search.get(paramName) ?? undefined,
    [search]
  );

  const setParam = useCallback(
    (paramName: string, paramValue: ParamType) => {
      if (paramValue !== null && paramValue !== undefined) {
        search.set(paramName, paramValue.toString());
      } else {
        search.delete(paramName);
      }
      setSearchParams(search);
    },
    [search, setSearchParams]
  );

  return useMemo(
    () => [
      paramName ? getParam(paramName) : undefined,
      (paramValue: ParamType) => {
        paramName && setParam(paramName, paramValue);
      },
    ],
    [getParam, setParam, paramName]
  );
};

export default useQueryParam;
